import AdminTableFiltersCard from "../ui/AdminTableFiltersCard";

type AdminFeedbackFiltersProps = {
  search: string;
  type: string;
  respondentRole: string;
  rating: string;
  createdFromDate: string;
  createdToDate: string;
  pageSize: number;
  onSearchChange: (value: string) => void;
  onTypeChange: (value: string) => void;
  onRespondentRoleChange: (value: string) => void;
  onRatingChange: (value: string) => void;
  onCreatedFromDateChange: (value: string) => void;
  onCreatedToDateChange: (value: string) => void;
  onPageSizeChange: (value: number) => void;
};

const AdminFeedbackFilters = ({
  search,
  type,
  respondentRole,
  rating,
  createdFromDate,
  createdToDate,
  pageSize,
  onSearchChange,
  onTypeChange,
  onRespondentRoleChange,
  onRatingChange,
  onCreatedFromDateChange,
  onCreatedToDateChange,
  onPageSizeChange,
}: AdminFeedbackFiltersProps) => (
  <AdminTableFiltersCard>
    <div className="flex flex-wrap items-end gap-3">
      <div className="min-w-[300px] flex-[2_1_360px]">
        <label htmlFor="admin-feedback-filter-search" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-myteengig-text-muted">
          Search
        </label>
        <input
          id="admin-feedback-filter-search"
          type="text"
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder="Email, message, source path"
          className="w-full rounded-lg border border-myteengig-border bg-white px-4 py-3 text-base text-myteengig-text-primary shadow-sm outline-none transition focus:border-myteengig-primary focus:ring-2 focus:ring-myteengig-primary/20"
        />
      </div>

      <div className="min-w-[200px] flex-[1_1_240px]">
        <label htmlFor="admin-feedback-filter-type" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-myteengig-text-muted">
          Type
        </label>
        <select
          id="admin-feedback-filter-type"
          value={type}
          onChange={(event) => onTypeChange(event.target.value)}
          className="h-[50px] w-full rounded-lg border border-myteengig-border bg-white px-4 text-sm font-medium text-myteengig-text-primary shadow-sm outline-none transition focus:border-myteengig-primary focus:ring-2 focus:ring-myteengig-primary/20"
        >
          <option value="">All types</option>
          <option value="POST_COMPLETION_WEBSITE_FEEDBACK">Completed gig website feedback</option>
          <option value="GENERAL_FEEDBACK">General feedback</option>
          <option value="BUG">Bug report</option>
          <option value="FEATURE_IDEA">Feature idea</option>
          <option value="QUESTION">Question</option>
        </select>
      </div>

      <div className="min-w-[140px] flex-[1_1_160px]">
        <label htmlFor="admin-feedback-filter-role" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-myteengig-text-muted">
          Role
        </label>
        <select
          id="admin-feedback-filter-role"
          value={respondentRole}
          onChange={(event) => onRespondentRoleChange(event.target.value)}
          className="h-[50px] w-full rounded-lg border border-myteengig-border bg-white px-4 text-sm font-medium text-myteengig-text-primary shadow-sm outline-none transition focus:border-myteengig-primary focus:ring-2 focus:ring-myteengig-primary/20"
        >
          <option value="">Any</option>
          <option value="TEEN">Teen</option>
          <option value="POSTER">Poster</option>
        </select>
      </div>

      <div className="min-w-[120px] flex-[1_1_140px]">
        <label htmlFor="admin-feedback-filter-rating" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-myteengig-text-muted">
          Rating
        </label>
        <select
          id="admin-feedback-filter-rating"
          value={rating}
          onChange={(event) => onRatingChange(event.target.value)}
          className="h-[50px] w-full rounded-lg border border-myteengig-border bg-white px-4 text-sm font-medium text-myteengig-text-primary shadow-sm outline-none transition focus:border-myteengig-primary focus:ring-2 focus:ring-myteengig-primary/20"
        >
          <option value="">Any</option>
          <option value="5">5</option>
          <option value="4">4</option>
          <option value="3">3</option>
          <option value="2">2</option>
          <option value="1">1</option>
        </select>
      </div>

      <div className="min-w-[160px] flex-[1_1_180px]">
        <label htmlFor="admin-feedback-filter-created-from" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-myteengig-text-muted">
          Created From
        </label>
        <input
          id="admin-feedback-filter-created-from"
          type="date"
          value={createdFromDate}
          onChange={(event) => onCreatedFromDateChange(event.target.value)}
          className="h-[50px] w-full rounded-lg border border-myteengig-border bg-white px-4 text-sm font-medium text-myteengig-text-primary shadow-sm outline-none transition focus:border-myteengig-primary focus:ring-2 focus:ring-myteengig-primary/20"
        />
      </div>

      <div className="min-w-[160px] flex-[1_1_180px]">
        <label htmlFor="admin-feedback-filter-created-to" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-myteengig-text-muted">
          Created To
        </label>
        <input
          id="admin-feedback-filter-created-to"
          type="date"
          min={createdFromDate || undefined}
          value={createdToDate}
          onChange={(event) => onCreatedToDateChange(event.target.value)}
          className="h-[50px] w-full rounded-lg border border-myteengig-border bg-white px-4 text-sm font-medium text-myteengig-text-primary shadow-sm outline-none transition focus:border-myteengig-primary focus:ring-2 focus:ring-myteengig-primary/20"
        />
      </div>

      <div className="min-w-[110px] flex-[0_1_120px]">
        <label htmlFor="admin-feedback-filter-page-size" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-myteengig-text-muted">
          Rows
        </label>
        <select
          id="admin-feedback-filter-page-size"
          value={pageSize}
          onChange={(event) => onPageSizeChange(Number(event.target.value))}
          className="h-[50px] rounded-lg border border-myteengig-border bg-white px-4 text-sm font-medium text-myteengig-text-primary shadow-sm outline-none transition focus:border-myteengig-primary focus:ring-2 focus:ring-myteengig-primary/20"
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={20}>20</option>
        </select>
      </div>
    </div>
  </AdminTableFiltersCard>
);

export default AdminFeedbackFilters;
